module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/hero-fd2a101ebd0af0b4b1e1de15c66c6bd3.png";